module.exports = __webpack_public_path__ + "assets/img/data.123a3df3.svg";